/** Routes that should keep their parent sidebar entry selected. */
const RELATED_ROUTES: Record<string, readonly string[]> = {
  "/dashboard/yourcolleague": ["/dashboard/yourcolleague/details"],
  "/dashboard/employee-directory": ["/dashboard/employeeprofile"],
};

function normalizeRoutePath(path: string): string {
  return path.replace(/\/+$/, "").toLowerCase() || "/";
}

function matchesRoute(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function isActiveSidebarRoute(pathname: string, menuPath: string | null): boolean {
  if (!menuPath) return false;
  const currentPath = normalizeRoutePath(pathname);
  const activeMenuPath = normalizeRoutePath(menuPath);
  if (currentPath === activeMenuPath) return true;

  return RELATED_ROUTES[activeMenuPath]?.some((route) => matchesRoute(currentPath, route)) ?? false;
}
